import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetdivisionpage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetDivisionsPage } = await import(
        /* webpackChunkName: "Login" */ '../../../components/pages/private/BudgetDivisionsPage'
      )
      return {
        default: BudgetDivisionsPage,
      }
    })}
    exact
    key={paths.budgetDivisions}
    path={paths.budgetDivisions}
  />,
]
